import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RouterConstants } from '../../../core/routing/constants/app-paths.constant';
import { LANGUAGE_MAPPINGS } from '../../constants/language-mappings.const';
import { SelectLanguageConstants } from './constants/select-lang.consts';
import { ConnectedUserAttributes } from '../../../modules/account/create-account/interfaces/create-account.i';
import { DataService } from '../../../core/data/data-service';
import { Base64 } from 'js-base64';
import { GlobalConstants } from '../../constants/global.constant';

@Component({
  selector: 'iposcen-select-lang',
  templateUrl: './select-lang.component.html',
  styleUrls: ['./select-lang.component.scss']
})
export class SelectLangComponent implements OnInit {

  pageName: string;
  languageHeading: string;
  langForm: FormGroup;
  selectedLanguage: string;
  buttonText: string;
  loginhref: string;
  languages: string[] = [];
  language: string;
  cancel: string;
  subHeading: string;
  selectLanguage: string;
  selectedLangCode: string;
  languageJSON = [] as any;
  browserLanguage: string;
  count = 0;
  paramObj = {};
  private sub: any;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private formbuilder: FormBuilder,
    private dataService: DataService) { }

  ngOnInit(): void {
    this.languageHeading = SelectLanguageConstants.LANGUAGE_HEADING;
    this.language = SelectLanguageConstants.LANGUAGE;
    this.cancel = SelectLanguageConstants.CANCEL;
    this.loginhref = RouterConstants.LOGIN_PAGE_LINK;
    this.selectLanguage = SelectLanguageConstants.SELECT_LANGUAGE;
    this.subHeading = SelectLanguageConstants.LANGUAGE_SUB_HEADING_DESC;
    this.langForm = this.formbuilder.group({
      lang: new FormControl('', [Validators.required])
    });
    this.sub = this.route.params.subscribe(params => {
      this.pageName = params.pageName;
    });

    // get query params
    this.route.queryParams.subscribe(getparams => {
      if (Object.keys(getparams).length !== 0){
        for (const [key, value] of Object.entries(getparams)) {
        // decoding object
        this.paramObj[Base64.decode(key)] = Base64.decode(value);
        }
        const queryParametersObj: ConnectedUserAttributes = this.paramObj as ConnectedUserAttributes;
        // setting prams to common service to get in create account comp
        this.dataService.setQueryParameters(queryParametersObj);
      } else {
        this.dataService.setQueryParameters(undefined);
      }
    });

    this.loadJSONObject(GlobalConstants.LANGUAGE_ENGLISH);
  }

  redirectToAccount() {
    if (this.pageName === SelectLanguageConstants.LOGIN_DEFAULT) {
      this.router.navigateByUrl(RouterConstants.LOGIN_PAGE_LINK);
    } else {
      this.router.navigateByUrl(RouterConstants.CREAT_ACCOUNT_LINK);
    }
  }

  languageSelected() {
    // gtm(google tag manager)
    window[GlobalConstants.DATA_LAYER].push({
      selectedLanguage : this.selectedLanguage
      });
    this.redirectToAccount();
  }

  trackByLanguage(index: number, el: string): number {
    return index;
  }

  setButtonText(selectedCode: string) {
    localStorage.setItem('preferredLanguageAccCreation', selectedCode);
  }

  loadJSONObject(defaultLanguage: string): void {
    localStorage.setItem('preferredLanguageAccCreation', defaultLanguage);
    LANGUAGE_MAPPINGS.forEach(element => {
      let display = false;
      if (defaultLanguage === element.langCode) {
        display = true;
      }
      const language = {
        langCode: element.langCode,
        langName: element.langName,
        langInEng: element.langInEng,
        checked: display
      };
      this.languageJSON.push(language);
    });
  }

}
